/**
 * gifWorkerUrl.js — адрес рабочего файла gif.js, полученный от сборщика.
 *
 * ПОЧЕМУ ЭТО ОТДЕЛЬНЫЙ ФАЙЛ В ОДНУ СТРОКУ.
 *
 * gif.js устроен так, что кодирование идёт в отдельном рабочем потоке, и ему
 * надо передать АДРЕС файла `gif.worker.js`. В программе этот адрес был задан
 * двумя разными неверными способами:
 *
 *   · `https://cdn.jsdelivr.net/...` — из интернета. Офлайн не работает вовсе,
 *     а офлайн — основной режим этой программы;
 *   · `/libs/gif.worker.js` — от корня сайта. Папки `libs` в проекте нет, файл
 *     не находился, и GIF молча не получался. Ровно та поломка, которую врач
 *     заметил как «кнопка ничего не делает».
 *
 * Соблазн — положить файл руками в `public/libs/`. Так делать не надо: адрес
 * `/libs/...` сломается в настольной оболочке, где программа живёт по схеме
 * `app://`, а не в корне сайта. Правильный способ — попросить адрес у
 * сборщика через `?url`: Vite сам положит файл в сборку, сам подставит
 * относительный путь и сам проследит за версией из `node_modules`.
 *
 * Вынесено в отдельный модуль потому, что запись `?url` — это указание
 * сборщику, а не обычный импорт: держать её рядом с логикой значит смешивать
 * два разных языка в одном файле.
 */

// eslint-disable-next-line import/no-unresolved
import адрес from 'gif.js/dist/gif.worker.js?url';

/** Адрес рабочего файла gif.js внутри собранной программы. */
export const АДРЕС_РАБОЧЕГО_ФАЙЛА = адрес;

export default АДРЕС_РАБОЧЕГО_ФАЙЛА;
